module.exports = __webpack_public_path__ + "img/snow_fall_00038.69455c2e.png";